import { useAppDisplayModeContext } from '@archipro-design/aria';
import { useKeyPress } from 'ahooks';

function isIgnoredElement(element: EventTarget | null) {
    const ignoredElementTypes = [
        HTMLInputElement,
        HTMLTextAreaElement,
        HTMLSelectElement,
    ];
    return ignoredElementTypes.some((type) => element instanceof type);
}

/**
 * Hook to enable entering edit mode by pressing the 'e' key on the page.
 * @param editPath The path to the edit page.
 * @param enabled The key press action is enabled.
 */
export function useSetEditMode(editPath: string, enabled: boolean) {
    const { mobile } = useAppDisplayModeContext();

    useKeyPress(['e'], (event) => {
        if (isIgnoredElement(event.target)) return;

        if (mobile) return;

        if (enabled) {
            // break out of SPA to go the edit page
            window.location.href = editPath;
        }
    });
}
